export default class Modal {
    constructor() {
        this.html = document.querySelector('html');
        this.modal = document.querySelector('#content-modal');
        this.modalButtons = document.querySelectorAll('[data-modal-target]');
        this.modalBackdrop = document.querySelector('.modal-backdrop');
        // Check if modal exists
        if (this.modal) {
            this.modalTitleContainer = this.modal.querySelector('.modal-title');
            this.modalContentContainer = this.modal.querySelector('.modal-body');
            this.closeButton = this.modal.querySelector('.btn-close');
            this.init();
            this.closeEvent();
        }
    }
    init() {
        if (!this.modal)
            return;
        const self = this;
        this.modalButtons.forEach((button) => {
            let id = button.getAttribute('data-modal-target');
            let title = button.getAttribute('data-modal-title');
            let contentId = button.getAttribute('data-modal-content');
            let contentEL = document.querySelector('#' + contentId);
            let content = contentEL.innerHTML;
            button.addEventListener('click', function (e) {
                e.preventDefault();
                self.modalTitleContainer.innerText = title;
                self.modalContentContainer.innerHTML = content;
                self.modalBackdrop.classList.add('show');
                self.modal.classList.add('show');
            });
        });
    }
    closeEvent() {
        let self = this;
        this.closeButton.addEventListener('click', function () {
            self.modalTitleContainer.innerText = "";
            self.modalContentContainer.innerHTML = "";
            self.modalBackdrop.classList.remove('show');
            self.modal.classList.remove('show');
        });
        this.modalBackdrop.addEventListener('click', function () {
            self.modalTitleContainer.innerText = "";
            self.modalContentContainer.innerHTML = "";
            self.modalBackdrop.classList.remove('show');
            self.modal.classList.remove('show');
        });
    }
}
